import { Inject, Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, map, Observable, Subscription, TeardownLogic } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BingMapsService implements OnDestroy {
    private _subrelease = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }

    private _MapLibraryReady = new BehaviorSubject<boolean>(false);
    get MapLibraryReady() {
        return this._MapLibraryReady.asObservable();
    }

    private _SessionKeySubject = new BehaviorSubject<string | null>(null);
    get SessionKey() {
        return this._SessionKeySubject.value;
    }

    constructor(@Inject('BingDocument') private bingdoc: Document, @Inject('BingWindow') private bingwin: Window) {
        if (bingdoc && !this._MapLibraryReady.value) {
            // Craft the URL to inject into the main page.
            const scriptTag = bingdoc.createElement('script');
            scriptTag.type = 'text/javascript';
            scriptTag.async = true;
            scriptTag.defer = true;
            const cbname = `bingmaps_prinprof_${new Date().getTime()}`;
            scriptTag.src = `https://www.bing.com/api/maps/mapcontrol?callback=${cbname}&key=ApIcbKEcasTXV23S_huB3J6fF8epnV74-8mqFhJqUHNsSgKr3MFSBYnXSByAHy99`;

            (<any>window)[cbname] = (x: any) => {
                this._MapLibraryReady.next(true);
            };

            bingdoc.head.appendChild(scriptTag);
        }
    }

    ngOnDestroy(): void {
        this._subrelease.unsubscribe();
    }

    // #region Get Session Key

    GetSessionKey(mapInstance: Microsoft.Maps.Map): Observable<string | null> {
        if (!this.SessionKey) {
            mapInstance.getCredentials((key) => {
                this._SessionKeySubject.next(key ?? null);
            });
        }

        return this._SessionKeySubject.asObservable();
    }

    // #endregion
}

export interface FocusPointInfo {
    Longitude: number | null;
    Latitude: number | null;
    Description: string;
    Route?: string | null;
}
